/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ApiError } from '../model/apiError';
import { FotoEvento } from '../model/fotoEvento';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class FotosEventosService {

    protected basePath = 'https://virtserver.swaggerhub.com/yohanyflores/kogui/1.0.0';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Obtiene informacion de la foto.
     * Obtiene informacion de la foto con el id especificado.
     * @param empresaId Especifica la empresaid.
     * @param eventoId El id de un evento asociado a la empresa.
     * @param fotoId El id de la foto.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteEmpresaByIdEventosByIdFotoById(empresaId: string, eventoId: string, fotoId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteEmpresaByIdEventosByIdFotoById(empresaId: string, eventoId: string, fotoId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteEmpresaByIdEventosByIdFotoById(empresaId: string, eventoId: string, fotoId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteEmpresaByIdEventosByIdFotoById(empresaId: string, eventoId: string, fotoId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling deleteEmpresaByIdEventosByIdFotoById.');
        }
        if (eventoId === null || eventoId === undefined) {
            throw new Error('Required parameter eventoId was null or undefined when calling deleteEmpresaByIdEventosByIdFotoById.');
        }
        if (fotoId === null || fotoId === undefined) {
            throw new Error('Required parameter fotoId was null or undefined when calling deleteEmpresaByIdEventosByIdFotoById.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.delete<any>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/eventos/${encodeURIComponent(String(eventoId))}/fotos/${encodeURIComponent(String(fotoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene las fotos del evento.
     * Obtiene las fotos del evento.
     * @param empresaId Especifica la empresaid.
     * @param eventoId El id de un evento asociado a la empresa.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresaByIdEventoByIdFotos(empresaId: string, eventoId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<FotoEvento>>;
    public getEmpresaByIdEventoByIdFotos(empresaId: string, eventoId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FotoEvento>>>;
    public getEmpresaByIdEventoByIdFotos(empresaId: string, eventoId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FotoEvento>>>;
    public getEmpresaByIdEventoByIdFotos(empresaId: string, eventoId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresaByIdEventoByIdFotos.');
        }
        if (eventoId === null || eventoId === undefined) {
            throw new Error('Required parameter eventoId was null or undefined when calling getEmpresaByIdEventoByIdFotos.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<FotoEvento>>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/eventos/${encodeURIComponent(String(eventoId))}/fotos/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene informacion de la foto.
     * Obtiene informacion de la foto con el id especificado.
     * @param empresaId Especifica la empresaid.
     * @param eventoId El id de un evento asociado a la empresa.
     * @param fotoId El id de la foto.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresaByIdEventosByIdFotoById(empresaId: string, eventoId: string, fotoId: string, observe?: 'body', reportProgress?: boolean): Observable<FotoEvento>;
    public getEmpresaByIdEventosByIdFotoById(empresaId: string, eventoId: string, fotoId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FotoEvento>>;
    public getEmpresaByIdEventosByIdFotoById(empresaId: string, eventoId: string, fotoId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FotoEvento>>;
    public getEmpresaByIdEventosByIdFotoById(empresaId: string, eventoId: string, fotoId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresaByIdEventosByIdFotoById.');
        }
        if (eventoId === null || eventoId === undefined) {
            throw new Error('Required parameter eventoId was null or undefined when calling getEmpresaByIdEventosByIdFotoById.');
        }
        if (fotoId === null || fotoId === undefined) {
            throw new Error('Required parameter fotoId was null or undefined when calling getEmpresaByIdEventosByIdFotoById.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<FotoEvento>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/eventos/${encodeURIComponent(String(eventoId))}/fotos/${encodeURIComponent(String(fotoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sube una foto o recurso asocida a un Evento.
     * Permite subir una fotos o un conjunto de fotos.
     * @param empresaId Especifica la empresaid.
     * @param eventoId El id de un evento asociado a la empresa.
     * @param fotoFile 
     * @param fotoUri 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postEmpresaByIdEventoByIdFotos(empresaId: string, eventoId: string, fotoFile?: Blob, fotoUri?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public postEmpresaByIdEventoByIdFotos(empresaId: string, eventoId: string, fotoFile?: Blob, fotoUri?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public postEmpresaByIdEventoByIdFotos(empresaId: string, eventoId: string, fotoFile?: Blob, fotoUri?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public postEmpresaByIdEventoByIdFotos(empresaId: string, eventoId: string, fotoFile?: Blob, fotoUri?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling postEmpresaByIdEventoByIdFotos.');
        }
        if (eventoId === null || eventoId === undefined) {
            throw new Error('Required parameter eventoId was null or undefined when calling postEmpresaByIdEventoByIdFotos.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: this.encoder});
        }

        if (fotoFile !== undefined) {
            formParams = formParams.append('fotoFile', <any>fotoFile) as any || formParams;
        }
        if (fotoUri !== undefined) {
            formParams = formParams.append('fotoUri', <any>fotoUri) as any || formParams;
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/eventos/${encodeURIComponent(String(eventoId))}/fotos/`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
